<template>
  <router-view />
</template>

<script>
export default {
  name: 'ConnectionMain'
};
</script>

<style></style>
